const exchangeValues = [
  { title: "Any", value: "" },
  { title: "Yes", value: "yes" },
];

export default exchangeValues;
